export const channelMask = function (rules, value, callback) {
    const reg = /^\d+([,]\d+)*$/;
    if (!reg.test(String(value))) {
        callback(new Error($t('integration.multiple_combined_numbers_are_separated_by_commas_and_are_numbers')))
    } else {
        let array = value.split(',');
        for (let item of array) {
            if (parseInt(item) > 255 || parseInt(item) < 1) {
                callback('存在不在1-255范围的值')
            }
        }
        callback();
    }
};

export const inNetInterval=function(rules, value, callback){
    let reg = /^\d{1,}$/
    if (value <= 0 || value > 16777215) {
        callback('范围值在1-167771215')
    } else if (!reg.test(value)) {
        callback($t('integration.only_numbers_can_be_entered'))
    } else {
        callback()
    }
}